import { useMutation, useSubscription } from '@apollo/client'
import React, { createContext, useContext, useEffect } from 'react'
import { 
        GET_POINT_REGISTER_VALUE,
        UPSERT_PARAMETERS_VALUE
      } from '../queries/geral_parameters'
import { UserInfoContext } from './UserInfoProvider';

export const ParametersContext = createContext()

export default function ParametersProvider({ children }) {

  const userInfo = useContext(UserInfoContext);
  const [insertDefaultParameters] = useMutation(UPSERT_PARAMETERS_VALUE);

  const { loading, error, data } = useSubscription(GET_POINT_REGISTER_VALUE, {
    variables: {
      point_register: "point_register",
      convocation_expires_type: "convocation_expires_type",
      receipt_called_hours: "receipt_called_hours",
      company_id: userInfo.companyId
    },
  });

  useEffect(() => {
    if (!data || !data.parameter) return;

    const hasParameter = (name) =>
      data.parameter.some((param) => param.parameter === name);

    const defaults = [
      { parameter: "point_register", value: true },
      { parameter: "convocation_expires_type", value: "default" },
      { parameter: "receipt_called_hours", value: false },
    ];

    defaults.forEach(({ parameter, value }) => {
      if (!hasParameter(parameter)) {
        insertDefaultParameters({
          variables: {
            company_id: userInfo.companyId,
            parameter,
            value,
          },
        });
      }
    });
  }, [data, insertDefaultParameters, userInfo.companyId]);

  if (error) return `Erro: ${error.message}`;
  if (loading) return "Carregando...";
 

	let parametersOrdered = {}

	if (data) {
    const parameters = {
      parameterData: data.parameter
    }
		parametersOrdered = parameters
	}

	return <ParametersContext.Provider value={parametersOrdered}>{children}</ParametersContext.Provider>
}